import { render, staticRenderFns } from "./view-rooms.vue?vue&type=template&id=0bfc7f1b&scoped=true&"
import script from "./view-rooms.vue?vue&type=script&lang=js&"
export * from "./view-rooms.vue?vue&type=script&lang=js&"
import style0 from "./view-rooms.vue?vue&type=style&index=0&id=0bfc7f1b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc7f1b",
  null
  
)

export default component.exports